export enum TypeOfTheme {
  SUPPLIER_CONNECT = 'supplier connect',
  TOP_SUPPLIER_CONNECT = 'top supplier connect',
  ACCOUNT_SETTING = 'account setting',
  DEFAULT = SUPPLIER_CONNECT,
}